import React from 'react';
import { Box, Grid, Button, Typography } from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useAnnouncementManagement from './useAnnouncementManagement';
import LoadingBackdrop from 'components/LoadingBackdrop';
import {
  AnnouncementSearch,
  AnnouncementList,
  AnnouncementFormUnified,
} from 'containers/pages/announcementManagement/components';

function AnnouncementManagement() {
  const { state, handler } = useAnnouncementManagement();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Title */}
      <Box>
        <Typography variant="h5" fontWeight="bold">
          Announcements
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage announcements displayed to CANdispatch guards.
        </Typography>
      </Box>

      {/* Header row: New Announcement button + Search */}
      <Grid
        container
        alignItems="stretch"
        spacing={2}
        wrap="nowrap"
        sx={{ width: { xs: '100%', md: '40%' } }}
      >
        {/* Left: New Announcement button */}
        <Grid item>
          <Button
            variant="contained"
            startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
            onClick={handler.onToggleForm}
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 2,
              height: '100%',
              whiteSpace: 'nowrap',
            }}
          >
            <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>NEW ANNOUNCEMENT</Box>
            <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>NEW</Box>
          </Button>
        </Grid>

        {/* Right: Search */}
        <Grid item xs>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <AnnouncementSearch
              searchInput={state.searchInput}
              onSearchInput={handler.onSearchInput}
              onReset={handler.onResetSearch}
            />
          </Box>
        </Grid>
      </Grid>

      {/* Conditional add form */}
      {state.isOpenForm && (
        <AnnouncementFormUnified
          mode="add"
          onSaveSuccess={handler.onRefreshAnnouncements}
        />
      )}

      {/* Main announcement list */}
      <AnnouncementList
        announcements={state.searchedAnnouncements}
        onDelete={handler.onDeleteAnnouncement}
        onRefresh={handler.onRefreshAnnouncements}
      />

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default AnnouncementManagement;
